import ValidationService from "../../services/ValidationService";
import {
    isNullOrUndefined
} from "../../helper/utils";
import AddressInputGroup from "./AddressInputGroup.vue";
import AcceptPrivacyPolicyCheck from "./AcceptPrivacyPolicyCheck.vue";

const ApiService = require("../../services/ApiService");
const NotificationService = window.CeresNotification;

Vue.component("registration-b2b", {

    components:
    {
        AddressInputGroup,
        AcceptPrivacyPolicyCheck
    },

    props: {
        shownFields: Object,
        requiredFields: Object,
        defaultSalutation: { type: String, default: "company" },
        backlink: String,
        classId: String,
        isFileInputShown: {
            type: Boolean,
            default: true
        },
        isFileInputRequired: {
            type: Boolean,
            default: true
        }
    },

    data()
    {
        return {
            selectedFile: null,
            selectedFileShowError: false,
            password: "",
            passwordRepeat: "",
            username: "",
            billingAddress: {
                countryId: null,
                stateId: null,
                gender: "company"
            },
            isDisabled: false,
            privacyPolicyAccepted: false,
            privacyPolicyShowError: false,
            enableConfirmingPrivacyPolicy: App.config.global.registrationRequirePrivacyPolicyConfirmation,
            honeypot: ""
        };
    },

    computed: {
        selectedFileName()
        {
            if (this.selectedFile)
            {
                return this.selectedFile.name;
            }

            return "";
        }
    },

    methods: {
        setFile(event)
        {
            if (event.target && event.target.files && event.target.files.length > 0)
            {
                this.selectedFile = event.target.files[0];
                this.selectedFileShowError = false;
            }
        },
        clearSelectedFile()
        {
            this.selectedFile = null;
            this.$refs.fileInput.value = "";
            this.selectedFileShowError = false;
        },
        /**
         * Validate the registration form
         */
        validateRegistration()
        {

            ValidationService.validate(this.$refs.registrationForm)
                .done(() =>
                {
                    if (this.selectedFile || !this.isFileInputRequired)
                    {
                        if (!this.enableConfirmingPrivacyPolicy || this.privacyPolicyAccepted)
                        {
                            this.sendRegistration();
                        }
                        else
                        {
                            this.privacyPolicyShowError = true;

                            NotificationService.error(
                                this.$translate("Ceres::Template.contactAcceptFormPrivacyPolicy", { hyphen: "&shy;" })
                            );
                            this.resetRecaptcha();
                        }
                    }
                    else
                    {
                        this.selectedFileShowError = true;

                        NotificationService.error(
                            this.$translate("B2BShop::Template.b2bFormFileRequired")
                        );
                    }
                })
                .fail(invalidFields =>
                {
                    if (!isNullOrUndefined(this.$refs.passwordHint) && invalidFields.indexOf(this.$refs.passwordInput) >= 0)
                    {
                        this.$refs.passwordHint.showPopper();
                    }

                    const invalidFieldNames = this.getInvalidFieldNames(invalidFields);

                    if (invalidFieldNames.length > 0)
                    {
                        NotificationService.error(
                            this.$translate("Ceres::Template.checkoutCheckAddressFormFields", { fields: invalidFieldNames.join(", ") })
                        );
                    }

                    ValidationService.markInvalidFields(invalidFields, "error");

                    if (this.enableConfirmingPrivacyPolicy && !this.privacyPolicyAccepted)
                    {
                        this.privacyPolicyShowError = true;

                        NotificationService.error(
                            this.$translate("Ceres::Template.contactAcceptFormPrivacyPolicy", { hyphen: "&shy;" })
                        );
                    }
                });
        },

        getInvalidFieldNames(invalidFields = [])
        {
            const fieldNames = [];

            for (const field of invalidFields)
            {
                let fieldName = field.lastElementChild.innerHTML.trim();

                fieldName = fieldName.slice(-1) === "*" ? fieldName.slice(0, fieldName.length - 1) : fieldName;
                fieldNames.push(fieldName);
            }

            return fieldNames;
        },

        /**
        * Send the registration
        */
        sendRegistration()
        {
            this.getUserObject().then((userObject) =>
            {
                this.isDisabled = true;

                ApiService.post("/rest/b2b/customer", userObject)
                    .done(response =>
                    {
                        ApiService.setToken(response);

                        if (!response.code)
                        {
                            document.dispatchEvent(new CustomEvent("onSignUpSuccess", { detail: userObject }));

                            NotificationService.success(
                                this.$translate("Ceres::Template.regSuccessful")
                            ).closeAfter(3000);

                            if (this.backlink !== null && this.backlink)
                            {
                                window.location.replace(decodeURIComponent(this.backlink));
                            }
                            else
                            {
                                location.reload();
                            }
                        }
                        else
                        {
                            NotificationService.error(
                                this.$translate("Ceres::Template.regError")
                            ).closeAfter(10000);
                        }

                        this.isDisabled = false;
                    })
                    .fail((error) =>
                    {
                        NotificationService.error(error.error).closeAfter(10000);
                        this.isDisabled = false;
                    });
            });
        },

        setAddressDataField({ field, value })
        {
            this.billingAddress.isPrimary = 1;
            this.billingAddress[field] = value;
            this.billingAddress = Object.assign({}, this.billingAddress);
        },

        /**
         * Handle the user object which is send to the server
         * @returns {{contact: {referrerId: number, typeId: number, options: {typeId: {typeId: number, subTypeId: number, value: *, priority: number}}}}|{contact: {referrerId: number, typeId: number, password: *, options: {typeId: {typeId: number, subTypeId: number, value: *, priority: number}}}}}
         */
        getUserObject()
        {
            const userObject = {
                contact: {
                    referrerId: 1,
                    typeId: 1,
                    options: {
                        typeId: {
                            typeId: 2,
                            subTypeId: 4,
                            value: this.username,
                            priority: 0
                        }
                    }
                },
                honeypot: this.honeypot
            };

            userObject.classId = this.classId;
            userObject.contact.password = this.password;
            userObject.billingAddress = this.billingAddress;

            const promise = this.getBase64(this.selectedFile);

            return promise.then((result) =>
            {
                if (result && this.selectedFile)
                {
                    userObject.fileName = this.selectedFile.name;
                    userObject.file = result;
                }
                return userObject;
            });
        },

        getBase64(file)
        {
            return new Promise(function(resolve, reject)
            {
                if (file)
                {
                    const reader = new FileReader();

                    reader.onload = function()
                    {
                        resolve(reader.result.split(",", 2)[1]);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                }
                else
                {
                    resolve("");
                }
            });
        },

        privacyPolicyValueChanged(value)
        {
            this.privacyPolicyAccepted = value;

            if (value)
            {
                this.privacyPolicyShowError = false;
            }
        }
    }
});
